import type React from 'react';

export const LandingSkeleton: React.FC = () => {
  return (
    <div id="LandingPage">
      <div className="home landingSkeleton">
        {/* Header skeleton */}
        <div className="landingSkeleton__header">
          <div className="skeleton skeleton--logo" />
          <div className="skeleton skeleton--avatar" />
        </div>

        {/* Content skeleton */}
        <div className="home__content">
          <div className="home__content__row">
            <div>
              <div className="landingSkeleton__card">
                <div className="skeleton skeleton--title" />
                <div className="skeleton skeleton--text" />
                <div className="skeleton skeleton--text" />
                <div className="skeleton skeleton--button" />
              </div>
            </div>
            <div>
              <div className="landingSkeleton__card">
                <div className="skeleton skeleton--title" />
                <div className="skeleton skeleton--row" />
                <div className="skeleton skeleton--row" />
                <div className="skeleton skeleton--row" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingSkeleton;
